import Modal from "react-modal";

const ModalContainer = ({ isOpen, closeModal,children }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Modal confirmation"
      style={{
        content: {
          height: "18rem",
          maxWidth: "25rem",
          margin: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: 999,
        },
      }}
    >
      {children}
    </Modal>
  );
};

export default ModalContainer;
